import React, { useEffect, useRef, useState } from 'react';

const BackPricesBoxPerticular = ({
  runner = [],
  runnerposition = 0,
  position = 0,
  handleOnBackClick,
  getBoxValue
}) => {
  const validation = (price) => {
    return price && price !== '-' && price !== 0 && price <= 1000.0;
  };

  const [highlighted, setHighlighted] = useState('');
  const prevPriceRef = useRef({ price: null, size: null });
  const firstRender = useRef(true);

  useEffect(() => {
    const current = runner?.[runnerposition]?.backPrices?.[position];
    const prev = prevPriceRef.current;

    if (!current) return;

    if (firstRender.current) {
      firstRender.current = false;
      prevPriceRef.current = { price: current.price, size: current.size };
      return;
    }

    if (current.price !== prev.price || current.size !== prev.size) {
      if (current.price > prev.price) {
        setHighlighted('highlight-green');
      } else if (current.price < prev.price) {
        setHighlighted('highlight-red');
      }

      prevPriceRef.current = { price: current.price, size: current.size };

      setTimeout(() => {
        setHighlighted('');
      }, 500);
    }
  }, [
    runner?.[runnerposition]?.backPrices?.[position]?.price,
    runner?.[runnerposition]?.backPrices?.[position]?.size
  ]);

  const back = runner?.[runnerposition]?.backPrices?.[position];

  return (
    <span
      className={`back ${highlighted}`}
      onClick={() => (validation(back?.price) ? handleOnBackClick() : null)}
    >
      {validation(back?.price) ? getBoxValue(back) : '-'}
    </span>
  );
};

export default BackPricesBoxPerticular;
